import React from 'react';
import PropTypes from 'prop-types';

import './ToastCollectionLegacyContent.scss';

function renderTitle(title) {
  if (!title) {
    return null;
  }

  return (
    <div className="toast-message-title-container">
      {typeof title === 'string' ? <h5 className="toast-message-title">{title}</h5> : title}
    </div>
  );
}

function renderIcon({ iconId, icon }) {
  if (iconId) {
    return (
      <div className="toast-message-icon-container">
        <svg className="toast-message-icon">
          <use xlinkHref={iconId} />
        </svg>
      </div>
    );
  }

  if (icon) {
    return (
      <div className="toast-message-icon-container">
        <span className="toast-message-icon">{icon}</span>
      </div>
    );
  }

  return null;
}

export default function ToastCollectionLegacyContent({ children = null, content = null, icon = null, iconId = null, title = null }) {
  return (
    <div className="toast-message" data-testid="toast-legacy-content">
      {renderIcon({ iconId, icon })}
      <div className="toast-message-content-wrapper">
        {renderTitle(title)}
        <div className="toast-message-content-container">
          {children}
          {content}
        </div>
      </div>
    </div>
  );
}

ToastCollectionLegacyContent.propTypes = {
  children: PropTypes.node,
  content: PropTypes.node,
  icon: PropTypes.node,
  iconId: PropTypes.string,
  title: PropTypes.node,
};
